module.exports = __webpack_public_path__ + "img/shouye.e521bbe8.png";